export const INITIAL_NUMBER_OF_SUGGESTED_FRIENDS_TO_SHOW = 7
